<div class="close" fxLayout fxLayoutAlign="end center">
  <button mat-icon-button (click)="dialogRef.close()"><mat-icon>close</mat-icon></button>
</div>
<div class="container" fxLayout="column" fxLayoutAlign="start center">
  <div class="text" innerHTML="{{'ORDER.SALARY_EXPLANATION' | translate}}"></div>
</div>
